<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">Contract Details</h5>
      <button
        ref="modalCloseBtn"
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-label="Close"
      >
        <i class="bi bi-x-circle"></i>
      </button>
    </div>
    <form @submit.prevent="updateCD">
      <div class="modal-body">
        <div
          class="partner-modal-section"
          v-if="requestRoute.modality === 'pool'"
        >
          <div class="partner-modal-info">
            <div class="info-content">
              <div class="info-row">
                <div class="row">
                  <div class="col-sm-7">
                    <ul>
                      <li>
                        Daily Income (Without CB):
                        <span class="highlighted-list-text"
                          >{{
                            vehicleRequest.dailyIncomeWithShuttleBonus(
                              formValue.fare_per_km,
                              requestRoute.distance,
                              requestRoute.duty_days,
                              requestRoute.pick_up_times?.length,
                              vehicleRequest.shuttleBonusObjFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              ).type,
                              vehicleRequest.shuttleBonusObjFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              ).base_bonus
                            )
                          }}
                          TK</span
                        >
                      </li>
                      <li>
                        Weekly Income (Without CB):
                        <span class="highlighted-list-text"
                          >{{
                            vehicleRequest.weeklyIncomeWithShuttleBonus(
                              formValue.fare_per_km,
                              requestRoute.distance,
                              requestRoute.duty_days,
                              requestRoute.pick_up_times?.length,
                              vehicleRequest.shuttleBonusObjFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              ).type,
                              vehicleRequest.shuttleBonusObjFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              ).base_bonus
                            )
                          }}
                          TK</span
                        >
                      </li>
                      <li>
                        Weekly Income (With CB):
                        <span class="highlighted-list-text"
                          >{{
                            vehicleRequest.weeklyIncomeWithShuttleAndCompletionBonus(
                              formValue.fare_per_km,
                              requestRoute.distance,
                              requestRoute.duty_days,
                              requestRoute.pick_up_times?.length,
                              vehicleRequest.shuttleBonusObjFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              ).type,
                              vehicleRequest.shuttleBonusObjFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              ).base_bonus,
                              vehicleRequest.completionBonusFromBonusArray(
                                requestRoute.trip_request_bonuses,
                                bonusObj
                              )
                            )
                          }}
                          TK</span
                        >
                      </li>
                      <li>
                        Fare Per KM:
                        {{ formValue.fare_per_km ? formValue.fare_per_km : 0 }}
                        TK
                      </li>
                    </ul>
                  </div>
                  <div class="col-sm-5">
                    <ul>
                      <li
                        v-for="(
                          bonus, bonusIndex
                        ) in requestRoute.trip_request_bonuses"
                        :key="bonusIndex"
                      >
                        {{
                          bonusObj[bonus.bonus_id]
                            ? bonusObj[bonus.bonus_id].bonus_name
                            : 'N/A Bonus'
                        }}: {{ bonus.base_bonus }}
                        {{ bonus.type === 'percentage' ? '%' : 'TK' }}
                      </li>
                    </ul>
                  </div>
                </div>
                <ul>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="partner-modal-section">
          <h5 class="section-heading">Driver Price</h5>
          <div class="partner-form assign-driver-form">
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="">Fare Per KM</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.fare_per_km"
                    required
                  />
                </div>
                <div class="form-group" v-if="requestRoute.modality !== 'pool'">
                  <label for="">Body Rent</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.body_rent"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <!-- <div class="form-group">
                  <label for="">Completion Bonus</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div>
                <div class="form-group">
                  <label for="">Bonus Minute</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div> -->
              </div>
              <div class="col-sm-6">
                <div
                  class="form-group"
                  v-if="requestRoute.modality === 'fleet-variable'"
                >
                  <label for="">Over Time/Hour Rate</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.overtime_payment_per_hour"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <div class="form-group" v-if="requestRoute.modality !== 'pool'">
                  <label for="">Lunch Allowance/Day</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                    min="0"
                    v-model="formValue.lunch_allowance_per_day"
                    :readonly="sameTRPriceOnDriverPrice"
                    required
                  />
                </div>
                <!-- <div class="form-group">
                  <label for="">Shuttle Bonus</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div>
                <div class="form-group">
                  <label for="">Bonus Amount</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter here"
                  />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-cancel"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          Close
        </button>
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">Update</button>
      </div>
    </form>
  </div>
</template>

<script>
import { vehicleRequest } from '@/store/vehicleRequest/vehicleRequest';
import http from '@/config/axios';

export default {
  props: ['requestRoute', 'bonusObj', 'driverDetails'],
  data() {
    return {
      vehicleRequest,
      formValue: {
        fare_per_km: null,
        body_rent: null,
        overtime_payment_per_hour: null,
        lunch_allowance_per_day: null
      },
      isLoading: false
    };
  },
  watch: {
    driverDetails() {
      this.formValue.fare_per_km = this.driverDetails.trip_per_price;
      this.formValue.body_rent = this.driverDetails.body_rent;
      this.formValue.overtime_payment_per_hour =
        this.driverDetails.overtime_payment_per_hour;
      this.formValue.lunch_allowance_per_day =
        this.driverDetails.lunch_allowance_per_day;
    }
  },
  methods: {
    emptyFormValues() {
      this.formValue.fare_per_km = null;
    },
    updateCD() {
      this.isLoading = true;
      let payload = {
        fare_per_km: this.formValue.fare_per_km
      };

      if (this.requestRoute.modality !== 'pool') {
        payload.body_rent = this.formValue.body_rent;
        payload.lunch_allowance_per_day =
          this.formValue.lunch_allowance_per_day;
      }
      if (this.requestRoute.modality === 'fleet-variable') {
        payload.overtime_payment_per_hour =
          this.formValue.overtime_payment_per_hour;
      }

      http
        .patch(
          `v2/partners/triprequestpartners/${this.driverDetails.id}`,
          payload
        )
        .then((response) => {
          this.isLoading = false;
          this.emptyFormValues();
          this.$emit('refreshData');
          this.$refs.modalCloseBtn.click();
          this.$partnerSwal.quickSuccessAlert.fire({
            title: 'Success!',
            text: response.data?.message
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$partnerSwal.errorToast.fire({
            title: 'Error!',
            text: error.response.data?.message
          });
        });
    }
  }
};
</script>

<style scoped>
.partner-modal-info .info-row {
  padding: 16px 0;
}
.partner-modal-info .info-row ul {
  margin-bottom: 0;
  padding-left: 0;
}
.partner-modal-info .info-row ul li {
  list-style: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 8px;
}
.partner-modal-info .info-row ul li:last-child {
  margin-bottom: 0;
}
.highlighted-list-text {
  font-weight: 500;
  color: #652f8f !important;
}
/* Form Design */
.assign-driver-form label {
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
}
.form-group {
  margin-bottom: 12px;
}
.ad-checkbox-group {
  display: flex;
  align-items: center;
}
.ad-checkbox-group span {
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
}
.ext-checkbox-group {
  margin-top: 16px;
  margin-bottom: 0;
}
.bordered-info-modal {
  border: 1px solid #a95eea;
}
</style>
